import React, { forwardRef } from 'react';
// import { gql, useMutation } from '@apollo/client';
// import {
//   ListingDetails_ListingData_listing,
//   ListingDetails_ListingData_listing_property_media,
// } from '../../../../../types/graph/ListingDetails_ListingData';
// import { isTemplateLiteral } from 'typescript';
import { DocumentIcon, SelectorIcon } from '@heroicons/react/outline';

interface IProps {
  url: string;
  onDeleteDocument: (arg: string) => void;
  [x: string]: any;
}

const Document = forwardRef<HTMLDivElement, IProps>(
  (
    { item, index, faded, style, onDeleteDocument, listeners, ...props },
    ref
  ) => {
    if (!item) return null;

    const inlineStyles = {
      opacity: faded ? '0.2' : '1',
      transformOrigin: '0 0',
      //height: index === 0 ? 270 : 130,
      gridRowStart: index === 0 ? 'span 2' : null,
      //gridColumnStart: index === 0 ? 'span 2' : null,
      //backgroundImage: `url("${item.filePath}")`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      //backgroundColor: 'grey',
      ...style,
    };

    const onDelete = () => {
      let delSid: string = item.sid;
      onDeleteDocument(delSid); //Updating one or more records
    };

    return (
      <div className="w-full h-full object-cover rounded-lg shadow">
        <div className="flow-root  mx-2">
          <ul role="list" className=" divide-y divide-gray-200">
            <li key={index} className="flex flex-col py-1 ">
              <div>
                <div
                  ref={ref}
                  style={inlineStyles}
                  className="flex w-1/8  items-center space-x-4"
                  {...props}
                >
                  <div className="max-w-0.5">
                    {/* <img className="h-8 w-8 rounded-full" alt="Document" />*/}
                    <SelectorIcon
                      className="w-8 h-16 text-gray-400"
                      {...listeners}
                    />
                  </div>
                  <div className="max-w-0.5">
                    {/* <img className="h-8 w-8 rounded-full" alt="Document" />*/}
                    <DocumentIcon className="w-8 h-16 text-gray-400" />
                  </div>
                  <div className="flex flex-row mx-2">
                    <a
                      className="flex flex-row mx-2 items-center text-sm font-medium text-primary hover:text-primary-light truncate"
                      href={item?.filePath!}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {!item.originalFileName
                        ? 'Original file name'
                        : item.originalFileName}
                    </a>
                    {/* <p className="flex flex-row mx-2 items-center text-sm text-gray-900 truncate">
                      {item.sid}
                    </p> */}
                  </div>
                  <div className="w-full flex justify-end">
                    <button
                      type="button"
                      className="bg-white inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-light"
                      onClick={onDelete}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    );
  }
);

export default Document;
